import React, { useEffect, useState } from "react";
import { MainContainer } from "../common/ui/MainContainer";
import { ResponsiveDeviceType } from "./ScreenMedia";
import { LogoRound } from "../common/ui/Logo";
import AppConfigService from "../../service/app_config/AppConfigService";
import Div from "../common/ui/Div";
import { appRoutes } from "../../routes/routes";
import { IconNormal } from "../common/ui/Icon";
import AppTheme from "../../service/app_config/AppTheme";
import { Col, Row } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { removeAllModal } from "../../libraries/state_reducers/widget/ModalsReducer";
import { navigate } from "../../service/navigation/Navigation";
import CacheStorage from "../../service/storage/CacheStorage";
import StorageKeys from "../../const/StorageKeys";
import UtilityHelper from "../../service/utilities/UtilityHelper";
import { setSiteTitle } from "../../libraries/state_reducers/global/GlobalReducer";

type Props = {
  backgroundColor?: string;
  className?: string;
  appBarTitle?: string | React.ReactNode;
  appBarAction?: React.ReactNode;
  appBarArrow?: React.ReactNode;
  appBarIcon?: string;
  children: React.ReactNode;
  bottomNavigationBar?: React.ReactNode;
  bottomNavigationButton?: React.ReactNode;
  yCenter?: boolean | false;
  xCenter?: boolean | false;
  disabledBack?: boolean;
  showBackArrow?: boolean;
  chatProfile?: React.ReactNode;
  isModal?: boolean;
  bodyClass?: string;
};

const Scaffold: React.FC<Props> = ({
  appBarTitle,
  className = "",
  appBarAction,
  appBarArrow,
  backgroundColor,
  children,
  bottomNavigationBar,
  bottomNavigationButton,
  yCenter,
  xCenter,
  disabledBack = false,
  showBackArrow = true,
  chatProfile,
  isModal = false,
  bodyClass = "",
  appBarIcon = "arrow_back",
}) => {
  const type: number = ResponsiveDeviceType();
  const dispatch = useDispatch();

  const minBrowserWidth: number = UtilityHelper.defaultWidthMin;

  const [size, setSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  const appNavActive =
    appBarTitle !== undefined ||
    chatProfile !== undefined ||
    bottomNavigationBar !== undefined ||
    bottomNavigationButton !== undefined
      ? "navigation-active"
      : "";
  let appNavStatus = "app-bar-bottom-nav-active";

  if (
    (appBarTitle !== undefined || chatProfile !== undefined) &&
    bottomNavigationBar === undefined &&
    bottomNavigationButton === undefined
  ) {
    appNavStatus = "app-bar-only";
  } else if (
    appBarTitle === undefined &&
    chatProfile === undefined &&
    (bottomNavigationBar !== undefined || bottomNavigationButton !== undefined)
  ) {
    appNavStatus = "bottom-nav-only";
  }

  const appendCSS = (href: string, id?: string) => {
    // Check if link already exists
    if (id && document.getElementById(id)) return;

    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = href;
    if (id) link.id = id;

    document.head.appendChild(link);
  };

  const applyLanguage = () => {
    const lang: string | "en" | "ar" = CacheStorage.getValue(
      StorageKeys.language
    );

    if (lang === "ar") {
      document.documentElement.dir = "rtl";
      document.documentElement.lang = "ar";

      appendCSS(
        "https://cdn.jsdelivr.net/npm/bootstrap@5.2.0/dist/css/bootstrap.rtl.min.css",
        "bootstrap-css"
      );

      //import("./../../assets/styles/style_rtl.min.css");
    }
  };

  const handleDeviceBack = () => {
    if (isModal && type < 3) {
      dispatch(removeAllModal());
    }
    navigate(-1);
  };

  const actionBarHtml: JSX.Element = appBarAction ? (
    <Col className="web-bar-action d-flex justify-content-end ">
      {appBarAction}
    </Col>
  ) : (
    <></>
  );

  useEffect(() => {
    const handleResize = () => {
      setSize({ width: window.innerWidth, height: window.innerHeight });
    };
    window.addEventListener("resize", handleResize);

    // Cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  /* useEffect(() => {
    if (!isModal) {
      AppConfigService.init();
      applyLanguage();
      dispatch(removeAllModal());
      //SocketService.initialize();
    }
  }, []); */

  useEffect(() => {
    if (!isModal) {
      AppConfigService.init();
      applyLanguage();
      dispatch(removeAllModal());
      //SocketService.initialize();

      if (disabledBack) {
        // Push current state once so there's something to go "back" from
        // console.log(window.location.href);
        //const currentPath = window.location.href;
        window.history.pushState(null, "", window.location.href);

        const handlePopState = (event: PopStateEvent) => {
          event.preventDefault();

          // 👇 Cancel the back navigation by pushing the same state again
          window.history.pushState(null, "", window.location.href);
        };

        window.addEventListener("popstate", handlePopState);
        return () => window.removeEventListener("popstate", handlePopState);
      }
    }

    dispatch(setSiteTitle(AppConfigService.get("company_name")));
    // eslint-disable-next-line
  }, []);

  return (
    <div
      className={`app-wrapper app-wrapper-${type} ${appNavActive} ${appNavStatus} ${className}`}
      style={{ backgroundColor: backgroundColor }}
    >
      {(appBarTitle !== undefined || chatProfile !== undefined) && (
        <div className="app-bar bgcolor-primary">
          {type === 3 ? (
            <>
              <div className="d-flex align-items-center">
                <Div className="px-md-5 mx-xl-5 w-100">
                  <div style={{ height: 40, display: `inline-block` }}>
                    <div
                      role="button"
                      onClick={() => navigate(appRoutes.routeNameHome)}
                    >
                      <LogoRound
                        url={AppConfigService.get("company_logo")}
                        className="login-logo"
                        size={40}
                        name={AppConfigService.get("company_name")}
                      />
                    </div>
                  </div>
                </Div>
              </div>
              <div className="d-flex align-items-center app-bar-nav font-gotham-bold font-size-15_16">
                {chatProfile !== undefined ? (
                  <>
                    {size.width < minBrowserWidth ? (
                      <MainContainer>
                        <Row className=" align-items-center">
                          <Col xs={4}>{appBarTitle}</Col>
                          <Col xs={6}>{chatProfile}</Col>
                          {actionBarHtml}
                        </Row>
                      </MainContainer>
                    ) : (
                      <Row className=" align-items-center w-100">
                        <Col xs={2}></Col>
                        <Col xs={3}>{appBarTitle}</Col>
                        <Col xs={5} className="pe-0">
                          <Row className=" align-items-center w-100">
                            <Col>{chatProfile}</Col>
                            <Col xs={2} className="px-0">
                              {actionBarHtml}
                            </Col>
                          </Row>
                        </Col>
                        <Col></Col>
                      </Row>
                    )}
                  </>
                ) : (
                  <MainContainer>
                    <Row className=" align-items-center">
                      <Col xs={4}>{appBarTitle}</Col>
                      {actionBarHtml}
                    </Row>
                  </MainContainer>
                )}
              </div>
            </>
          ) : (
            <Div className="row h-100 w-100 app-bar-device  mx-0 ">
              <Col className="app-bar-back " xs={2} sm={1}>
                {appBarArrow ??
                  (showBackArrow && (
                    <div role="button" onClick={() => handleDeviceBack()}>
                      <IconNormal
                        name={
                          UtilityHelper.isNotEmpty(appBarIcon)
                            ? appBarIcon
                            : "arrow_back"
                        }
                        color={AppTheme.themeFont}
                      />
                    </div>
                  ))}
              </Col>
              <Col
                className={`${
                  chatProfile !== undefined
                    ? "d-flex align-items-center"
                    : "d-center text-center"
                } px-0`}
              >
                {chatProfile ?? (
                  <span className="font-size-20 font-gotham-bold ellipsis line-1">
                    {appBarTitle}
                  </span>
                )}
              </Col>
              <Col className="app-bar-action" xs={2} sm={1}>
                {appBarAction ?? <></>}
              </Col>
            </Div>
          )}
        </div>
      )}
      <Div
        className={`app-body overflow-auto ${
          yCenter !== undefined || xCenter !== undefined ? "d-flex" : ""
        } ${yCenter ? "align-items-center" : ""} ${
          xCenter ? "justify-content-center" : ""
        } ${bodyClass}`}
      >
        {children}
      </Div>
      {(bottomNavigationBar != null || bottomNavigationButton != null) && (
        <Div
          className={` d-flex align-items-center ${
            bottomNavigationBar != null
              ? "bottom-navigation-bar bgcolor-primary"
              : ""
          } ${bottomNavigationButton != null ? "pt-4 pb-5" : ""}`}
        >
          <MainContainer
            className={`${bottomNavigationButton != null ? "d-center" : ""}`}
          >
            {bottomNavigationBar}
            {bottomNavigationButton}
          </MainContainer>
        </Div>
      )}
    </div>
  );
};

export default Scaffold;
